export const PREFIX = 'WAIT_LIST';

export const LIST_WAIT_LIST = `${PREFIX}/LIST`;
export const LAST_UPDATE_WAIT_LIST = `${PREFIX}/LAST_UPDATED`;
export const SET_WAIT_LIST = `${PREFIX}/SET`;
